import { render, staticRenderFns } from "./ConcernIndustry.vue?vue&type=template&id=2946f4aa&scoped=true"
import script from "./ConcernIndustry.vue?vue&type=script&lang=js"
export * from "./ConcernIndustry.vue?vue&type=script&lang=js"
import style0 from "./ConcernIndustry.vue?vue&type=style&index=0&id=2946f4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946f4aa",
  null
  
)

export default component.exports